import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';
import { DeleteDialogProps } from './DeleteDialog.types';
import { Close } from '@mui/icons-material';

export const DeleteDialog = ({
  openDeleteDialog,
  isDeleting,
  isMobile,
  userToDelete,
  setOpenDeleteDialog,
  handleConfirmDelete
}: DeleteDialogProps) => {
  const handleClose = () => {
    if (!isDeleting) {
      setOpenDeleteDialog(false);
    }
  };

  return (
    <Dialog
      open={openDeleteDialog}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          ...(isMobile && {
            margin: 0,
            width: '100%',
            height: '100%',
            maxHeight: '100%',
            borderRadius: 0
          })
        }
      }}
    >
      <DialogTitle
        sx={{
          color: '#d32f2f',
          ...(isMobile && {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          })
        }}
      >
        Підтвердження видалення
        {isMobile && (
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Ви дійсно хочете видалити користувача <strong>{userToDelete?.display_name}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          ...(isMobile && {
            flexDirection: 'column',
            gap: 1,
            p: 2,
            '& > :not(style) + :not(style)': {
              marginLeft: 0
            }
          })
        }}
      >
        <Button
          onClick={handleClose}
          disabled={isDeleting}
          sx={{
            color: '#666',
            ...(isMobile && { width: '100%', order: 2 })
          }}
        >
          Скасувати
        </Button>
        <Button
          onClick={handleConfirmDelete}
          disabled={isDeleting}
          variant="contained"
          sx={{
            backgroundColor: '#d32f2f',
            '&:hover': { backgroundColor: '#c62828' },
            ...(isMobile && { width: '100%', order: 1 })
          }}
        >
          {isDeleting ? <CircularProgress size={20} sx={{ color: 'white' }} /> : 'Видалити'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
